import { clientOnly } from '@solidjs/start';
import { Meta, Title } from '@solidjs/meta';
import { Show, Suspense } from 'solid-js';
import { Button, Heading, Link, TextLink, Container, Page } from '@troon/ui';
import { IconCircleCheck } from '@troon/icons/circle-check';
import { useLocation } from '@solidjs/router';
import { IconArrowLeftMd } from '@troon/icons/arrow-left-md';
import { useUser } from '../../../providers/user';
import { productName } from '../../../modules/access-products';
import { getConfigValue } from '../../../modules/config';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

const StripeProvider = clientOnly(async () => ({
	default: (await import('@troon/payments/stripe')).StripeProvider,
}));

export default function CheckoutLayout(props: RouteSectionProps) {
	const user = useUser();
	const location = useLocation<{ redirect?: string }>();

	return (
		<div class="-mb-6 min-h-svh bg-neutral-100 md:-mb-12">
			<Page>
				<Suspense>
					<Show when={user()?.troonAccessProductType} fallback={<NoCurrentUserAccess {...props} />}>
						{(productType) => (
							<Container size="xsmall">
								<div class="flex flex-col gap-8">
									<div class="flex flex-col items-center gap-6 text-center">
										<IconCircleCheck class="text-8xl text-brand" />
										<Heading as="h1" size="h2">
											Your {productName[productType()]} is already active!
										</Heading>

										<p>
											<TextLink href="/account/subscription">
												Manage your your {productName[productType()]} plan
											</TextLink>
											.
										</p>

										<Button as={Link} href={location.state?.redirect ?? '/tee-times'}>
											<Show when={location.state?.redirect} fallback="Find a Tee Time">
												<IconArrowLeftMd /> Back
											</Show>
										</Button>
									</div>
								</div>
							</Container>
						)}
					</Show>
				</Suspense>
			</Page>
		</div>
	);
}

function NoCurrentUserAccess(props: RouteSectionProps) {
	return (
		<>
			<Meta name="robots" content="noindex" />
			<Title>Checkout | Membership | Golf with Access</Title>
			<StripeProvider publishableKey={getConfigValue('STRIPE_PUBLISHABLE_KEY')}>{props.children}</StripeProvider>
		</>
	);
}
export const route = {
	info: { nav: { appearance: 'extra-minimal', sticky: false }, banner: { hide: true } },
} satisfies RouteDefinition;
